export default "__VITE_ASSET__DpKme4vN__"